import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import faTranslations from './locales/fa.json'
import enTranslations from './locales/en.json'

i18n.use(initReactI18next).init({
  resources: {
    fa: { translation: faTranslations },
    en: { translation: enTranslations },
  },
  lng: 'fa',
  fallbackLng: 'fa',
  interpolation: { escapeValue: false },
})

export default i18n
